<template>
	<div>
    <div class="row">
      <div class="col-12 col-md-6">
		    <h2>Gestione Motori<span v-if="client"> di {{client.name}}</span></h2>
      </div>
      <div class="col-12 col-md-6 text-md-right">
    		<router-link :to="`/clients/${$route.params.clientId}/engine/create`">
    			<base-button type="primary">
            <i class="tim-icons icon-simple-add"></i>
    				Crea nuovo
    			</base-button>
    		</router-link>
        
      </div>
    </div>

    <engines-table />
  </div>
</template>
<script>
import EnginesTable from '@/components/Engines/EnginesTable.vue';
// import enginesTable from './ClientsTable.vue';
import { mapState } from 'vuex'


export default{
  computed: {
    ...mapState({
      // engines: state => state.engines.engines.docs,
      client: state => state.clients.client
    })
  },
  components: {
    EnginesTable
  },
  mounted() {
    this.getClient($route.params.clientId)
  },
  methods: {
    ...mapActions('clients', {
      getClient: 'get'
    }),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
  },
}	
</script>